import { useEffect, useState } from 'react';

/**
 * True when the viewport is narrower than `maxWidth`.
 *
 * Blog figures use this to hand the chart engine a DIFFERENT layout on phones
 * (smaller gutters, smaller label fonts) rather than letting a desktop layout
 * scale down, which clips axis labels inside a 343px column.
 */
export const useIsNarrow = (maxWidth = 480) => {
  const [narrow, setNarrow] = useState(
    () => typeof window !== 'undefined' && window.innerWidth <= maxWidth,
  );

  useEffect(() => {
    const onResize = () => setNarrow(window.innerWidth <= maxWidth);
    onResize();
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, [maxWidth]);

  return narrow;
};
